import { ApiResponse } from '../../types/globalTypes';
import { API_BASE_URL } from '../../constants';
import axios from 'axios';

export const fetchHomePageData = async (): Promise<ApiResponse> => {
  const response = await axios.get(`${API_BASE_URL}/home_page`);

  if (response.status !== 200) {
    throw new Error('Failed to fetch data');
  }

  const data: ApiResponse = await response.data;
  return data;
};
